import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import type EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';
import { isRoom, getRoomEmailFromLocation } from 'owa-location-persona';

export default function getAttendeesAndLocationsAsEmailAddresses(
    event: CalendarEvent
): EmailAddressWrapper[] {
    return [
        ...(event.RequiredAttendees
            ? event.RequiredAttendees.map(attendee => attendee.Mailbox)
            : []),
        ...(event.OptionalAttendees
            ? event.OptionalAttendees.map(attendee => attendee.Mailbox)
            : []),
        ...convertLocationsToEmailAddressWrappers(event.Locations),
    ];
}

function convertLocationsToEmailAddressWrappers(
    locations: EnhancedLocation[]
): EmailAddressWrapper[] {
    return locations
        ? locations.filter(location => isRoom(location.PostalAddress)).map(getRoomEmailFromLocation)
        : [];
}
